export default __webpack_public_path__ + "static/media/t5.792d879c.svg";